import { Address } from "./address";

export class UserAndAccountSpecificDetails{
    constructor(accountCode: string, address: Address){
        this.accountCode = accountCode;
        this.company = address.company;
        this.name = address.name;
        this.address = new ShippingAddress();
        this.address.address1 = address.line1;
        this.address.address2 = address.line2;
        this.address.address3 = address.line3;
        this.address.address4 = address.line4;
        this.address.address5 = address.line5;
        this.address.address6 = address.line6;
        this.address.city = address.city;
        this.address.country = address.country;
        this.address.state = address.state;
        this.address.zipCode = address.zipCode;
        this.phone = address.phonenumber;
    }

    accountCode?: string;
    company?: string;
    name?: string;
    address?: ShippingAddress;
    phone?: string;
}

export class ShippingAddress{
    address1?: string;
    address2?: string;
    address3?: string;
    address4?: string;
    address5?: string;
    address6?: string;
    city?: string;
    country?: string;
    state?: string;
    zipCode?: string;
    phone?: string;
}